export default "__VITE_ASSET__BxyjOCvT__"